import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const EscapeHatchAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "escape-hatch" */ './escape-hatch'),
  componentName: 'EscapeHatch',
});
